import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { CircularProgress, Box, Typography } from "@mui/material";

const DownloadInvoiceByPdfLink = () => {
  const params = useParams();
  const linktoken = params.hash;
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [errorMessage, setErrorMessage] = useState(
    "The file download failed. Please check if the link is correct or try again later."
  );
  const hasDownloaded = useRef(false); // 使用ref来跟踪是否已经下载过

  useEffect(() => {
    // 如果已经下载过或者没有token，直接返回
    if (hasDownloaded.current || !linktoken) {
      if (!linktoken) {
        setStatus("error");
        setErrorMessage("Download link is invalid.");
      }
      return;
    }

    const downloadPdf = async () => {
      try {
        hasDownloaded.current = true; // 标记为已开始下载

        const requestUrl = `${
          import.meta.env.VITE_API_URL
        }/pdfs/${linktoken}?download=y`;
        const link = document.createElement("a");
        link.href = requestUrl;
        link.rel = "noopener";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setStatus("success");

        // 下载成功后3秒关闭窗口（如果是弹出窗口）
        setTimeout(() => {
          if (window.opener && !window.opener.closed) {
            window.close();
          }
        }, 3000);
      } catch (err) {
        console.error("Error downloading file:", err);
        setErrorMessage(
          err instanceof Error
            ? err.message
            : "The file download failed. Please try again later."
        );
        setStatus("error");
      }
    };

    downloadPdf();

    // 清理函数（如果需要的话）
    return () => {
      // 可以在这里添加任何清理逻辑
    };
  }, [linktoken]); // 依赖数组中只有linktoken

  // 极简状态显示
  if (status === "loading") {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        flexDirection="column"
      >
        <CircularProgress />
        <Typography variant="body2" sx={{ mt: 2 }}>
          Preparing your download...
        </Typography>
      </Box>
    );
  }

  if (status === "error") {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        flexDirection="column"
        p={2}
      >
        <Typography color="error" variant="h6" gutterBottom>
          Download File Failed
        </Typography>
        <Typography textAlign="center" variant="body2">
          {errorMessage}
        </Typography>
      </Box>
    );
  }

  // 成功状态
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      flexDirection="column"
      p={2}
    >
      <Typography variant="h6" gutterBottom color="primary">
        Download File Success
      </Typography>
      <Typography textAlign="center" variant="body2">
        Download will start automatically. If it doesn't, please check your
        browser's download settings.
      </Typography>
    </Box>
  );
};

export default DownloadInvoiceByPdfLink;
